var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFInst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.979,
    height: 15.66,
    viewBox: "0 0 14.979 15.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oval-1",
    d: "M28.946,27.8c.013-.07.022-.14.033-.21V15.065c-.01-.069-.019-.138-.032-.206a1.651,1.651,0,0,0-1.365-1.344c-.028,0-.056-.01-.084-.015H15.481c-.073.014-.145.024-.217.041a1.662,1.662,0,0,0-1.249,1.42c0,.029-.01.058-.015.088V27.612c.014.08.025.16.042.239a1.649,1.649,0,0,0,1.36,1.293c.032,0,.064.01.1.016H27.482c.078-.014.156-.025.233-.043A1.661,1.661,0,0,0,28.946,27.8Zm-13.325-.961a.62.62,0,0,0,.595.62H26.761a.62.62,0,0,0,.6-.622q0-3.472,0-6.944V19.85h-1.43a5.107,5.107,0,0,1,.185,2.06,4.933,4.933,0,0,1-.646,1.952,4.762,4.762,0,0,1-1.365,1.5,4.486,4.486,0,0,1-4.883.22,4.66,4.66,0,0,1-1.809-1.905,5.059,5.059,0,0,1-.363-3.825H15.62v.042Q15.62,23.368,15.621,26.844Zm5.8-2.343a3.178,3.178,0,1,0-2.965-3.22A3.106,3.106,0,0,0,21.42,24.5Zm5.937-7.61q0-.742,0-1.483a.619.619,0,0,0-.607-.637H25.335a.621.621,0,0,0-.607.638c0,.49,0,.98,0,1.471a.74.74,0,0,0,.036.218.605.605,0,0,0,.593.422h.683c.246,0,.494,0,.74,0A.616.616,0,0,0,27.357,16.892Zm0,0",
    transform: "translate(-14 -13.5)",
    fill: "#312C40",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFInst);
export default __webpack_public_path__ + "static/media/f-inst.282ed55794ee47529342f8f3f68f95a4.svg";
export { ForwardRef as ReactComponent };